import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import * as Actions from 'actions';
import * as Api from 'api';

class SelectTypes extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'SelectTypes';
    this.state = {
      types : []
    }

    this.fetchTypes = this.fetchTypes.bind(this);
    this.refresh = this.refresh.bind(this);
  }
  propTypes = {
    accountId : PropTypes.string,
    entity : PropTypes.string.isRequired,
    field : PropTypes.string.isRequired,
    value : PropTypes.string,
    name : PropTypes.string,
    onChange : PropTypes.func.isRequired,
  }
  fetchTypes() {
    const { accountId, entity, field } = this.props;
    Api.getTypes(accountId, entity, field)
      .then(types => this.setState({types}))
      .catch(error => {
        console.error(error);
        this.props.notify({message : error.message})
      });
  }
  componentWillMount() {
    this.fetchTypes();
  }
  refresh() {
    this.fetchTypes();
  }
  render() {
    const { types } = this.state;
    const { onChange, value, name } = this.props;
    return(
      <Select
        name={name}
        value={value}
        options={types.map( ({value}) => ({value, label : value}) )}
        onChange={onChange}
      />
    )
  }
}

const mapStateToProps = ({connection}) => ({ accountId : connection.user ? connection.user.account_owner || connectin.user._id : undefined });

export default connect(mapStateToProps, Actions)(SelectTypes);



// WEBPACK FOOTER //
// ./src/browser/components/ui/select-types.js